export const createMessage = `
    mutation createMessage($input: CreateMessageInput!) {
        createMessage(input:$input) {
            id
            messageId
            status
            created
            updated  
    }
}`;

export const sendEmail = `
    mutation sendEmail($input: SendEmailInput!) {
        sendEmail(input:$input) {
            id
            messageId
            status
            inReplyTo
            created
            updated
        }
}`;

export const updateMessage = `
    mutation updateMessage($input: UpdateMessageInput!) {
        updateMessage(input:$input){
             id
             messageId
             fromText
             toText
             subject
             date,
             htmlPath
             textPath
             attachments {
                filename
                filePath
                objectKey
             }
             tagIds
             tags {
                items {
                  id
                  name
                }
             }
             status
             inReplyTo
             created
             updated
        }
}`;

export const deleteMessage = `
    mutation deleteMessage($input: DeleteMessageInput!) {
        deleteMessage(input:$input) 
}`;

/**
 * FNP-1521: generate test messages into the caller's own mailbox.
 *
 * DEV AND TEST ONLY. The resolver behind this field is not constructed in the
 * prod stack, so in prod the field has no compute behind it and resolves to
 * null — the capability is absent, not merely hidden by the UI.
 */
export const generateTestMessages = `
    mutation generateTestMessages($input: GenerateTestMessagesInput!) {
        generateTestMessages(input:$input){
            generated
            aliasId
            items {
                id
                subject
                fromText
                toText
                status
                tagIds
                created
            }
        }
}`;
